export const supportColors = {
    crimson: '#D0354C',
    coral: '#EF865C',
    aqua: '#A2D6E0',
    indigo: '#6E6AB5',
    teal: '#16BD71',
    gold: '#ECC22A'
};

export const grey = {
    grey000: '#212121',
    grey100: '#303030',
    grey200: '#424242',
    grey300: '#666666',
    grey400: '#9E9E9E',
    grey500: '#C4C4C4',
    grey600: '#E0E0E0',
    grey700: '#E8E8E8',
    grey800: '#F5F5F5',
    grey900: '#FAFAFA'
};

export const coral = {
    lightest: '#C8C8FF',
    lighter: '#9595FB',
    light: '#6060E9',
    regular: '#3939CD',
    dark: '#1E1E97',
    darker: '#10103D'
};

export const algae = {
    lighter: '#7CFEE4',
    light: '#3BF4D0',
    regular: '#07E1B8',
    dark: '#009D7E',
    darker: '#004235'
};

export const bermuda = {
    lighter: '#A1FBFF',
    light: '#59F6FE',
    regular: '#1FEAF7',
    dark: '#01D0DA',
    darker: '#075F63'
};
